var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description__item"},[_c('BaseTypography',{attrs:{"variant":"subtitle-2"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("default",[_c('BaseTypography',{attrs:{"variant":"subtitle-3"}},[_vm._v(_vm._s(_vm.value))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }